import React from 'react'
import {
    TableRow,
    TableHeaderCell,
    TableHeader,
    TableFooter,
    TableCell,
    TableBody,
    MenuItem,
    Icon,
    Menu,
    Table,
} from 'semantic-ui-react'
import { getPaginationRange } from '../utils'

const TableWithPagination = (props) => {

    const {
        loading,
        activeRecord,
        columns,
        records,
        currentPage,
        totalPages,
        sort,
        onPageChange,
        onPrevPage,
        onNextPage,
        filterMap,
        onFilter,
        onSort,
        onActiveRecord,
        bodyMap,
        sortMap
    } = props

    const pages = getPaginationRange(totalPages, currentPage, 1)

    const renderColumns = columns.map(({ id, header, filterBody = '' }) => {
        const Filter = filterBody ? filterMap[filterBody] : null
        const TemplateSort = sortMap.sortTemplate || null
        return (
            <TableHeaderCell key={id}>
                <span>
                    {header}&nbsp;
                    <TemplateSort {...{ name: id, sort, callback: onSort }} />
                </span>
                {Filter && <Filter name={id} callback={onFilter} />}
            </TableHeaderCell>
        )
    })

    const renderRecords = records.map((rowItem, index) => {
        return (
            <TableRow key={index} onClick={() => onActiveRecord(rowItem)} style={{ backgroundColor: rowItem?.id === activeRecord?.id ? 'lightcyan' : '' }}>
                {columns.map((cellItem, index) => {
                    const BodyTemplate = cellItem?.body ? bodyMap[cellItem?.body] : null
                    return (
                        <TableCell key={cellItem?.id}>
                            {cellItem?.id ? BodyTemplate ? <BodyTemplate value={rowItem?.[cellItem?.id]} /> : rowItem?.[cellItem?.id] : ''}
                        </TableCell>
                    )
                })}
            </TableRow>
        )
    })

    const renderPages = pages.map((page, idx) => (
        <MenuItem
            as='a'
            key={idx}
            disabled={page === '...' || loading}
            onClick={() => typeof page === 'number' && onPageChange(page)}
            className={`${page === currentPage ? 'bg-color-lighgray' : ''} ${page === '...' ? 'cursor-pointer-default' : 'cursor-pointer'}`}
        >
            {page}
        </MenuItem>
    ))

    return (
        <Table celled>
            <TableHeader>
                <TableRow>
                    {renderColumns}
                </TableRow>
            </TableHeader>

            <TableBody>
                {renderRecords}
            </TableBody>

            <TableFooter>
                <TableRow>
                    <TableHeaderCell colSpan={columns.length}>
                        <Menu floated='left' pagination>
                            <MenuItem disabled={currentPage === 1 || loading || totalPages < 1} as='a' icon onClick={onPrevPage}>
                                <Icon name='chevron left' />
                            </MenuItem>
                            {renderPages}
                            <MenuItem disabled={currentPage === totalPages || loading || totalPages < 1} as='a' icon onClick={onNextPage}>
                                <Icon name='chevron right' />
                            </MenuItem>
                        </Menu>
                    </TableHeaderCell>
                </TableRow>
            </TableFooter>
        </Table>
    )
}

export default TableWithPagination